import React from 'react';
import classnames from 'classnames';
import Icon from '../icon/index';
class SelectArrow extends React.Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { disabled, onClick } = this.props;
            !disabled && onClick && onClick();
        };
    }
    render() {
        const { title, tips, selectText, showArrow, disabled, style, className, iconSize } = this.props;
        const selectCls = classnames('cfm_select_arrow', {
            'cfm_select_arrow_disabled': disabled,
        }, className);
        return (<div onClick={this.handleClick} className={selectCls} style={style}>
        <div className='cfm_select_arrow_left'>
          <div className='cfm_select_arrow_title'>{title}</div>
          {tips
            ? <div className='cfm_select_arrow_tips'>{tips}</div>
            : null}
        </div>
        {selectText
            ? <div className='cfm_select_arrow_right'>
              <div className='cfm_select_arrow_select'>{selectText}</div>
            </div>
            : null}
        {showArrow ? <Icon size={iconSize} className='cfm_select_arrow_icon' type='right'/> : null}
      </div>);
    }
}
SelectArrow.defaultProps = {
    title: '',
    tips: '',
    showArrow: true,
    style: {},
    onClick: () => { },
    iconSize: 'xxs',
};
export default SelectArrow;



// WEBPACK FOOTER //
// ./components/select-arrow/index.tsx